import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import uniqueId from 'lodash/uniqueId';
import FormBuilder from '../helpers/form-builder';
import { getMultilineText } from '../../../../../general/js/utils';
import userService from '../../../../../general/js/user/user-service';
import { REFERRAL_CODE } from '../../../../../general/js/user/constants';
import * as userAccountActions from '../../../store/actions/user-account-actions';

class UserReferralForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formData: props.formData
        };
    }

    componentDidMount() {
        this.resolveReferralCode();
    }

    componentDidUpdate(prevProps) {
        if (!prevProps.isReferralCodeLoaded && this.props.isReferralCodeLoaded) {
            const receivedCode = this.props.referralCodeData;

            if (!receivedCode) {
                userService.setDataInLocalStorage(REFERRAL_CODE, 'NONE_FOUND');
                this.updateFormFieldValue(' ');
            } else {
                userService.setDataInLocalStorage(REFERRAL_CODE, receivedCode);
                this.updateFormFieldValue(receivedCode);
            }
        }
    }

    resolveReferralCode() {
        const { formData, actions, userEmail } = this.props;
        if (formData.personalReferralCode && formData.personalReferralCode.defaultValue) {
            return;
        }

        const storageCode = userService.getDataFromLocalStorage(REFERRAL_CODE);
        if (storageCode === 'NONE_FOUND') {
            this.updateFormFieldValue(' ');
            return;
        }

        if (storageCode) {
            this.updateFormFieldValue(storageCode);
            return;
        }
        const { getUserReferralCallbackUrl } = formData;
        if (userEmail) {
            actions.getUserReferralCode(getUserReferralCallbackUrl, userEmail);
        }
    }

    updateFormFieldValue(code) {
        this.setState((prevState) => ({
            formData: {
                ...prevState.formData,
                personalReferralCode: {
                    ...prevState.formData.personalReferralCode,
                    defaultValue: code
                }
            }
        }));
    }

    render() {
        const { formData } = this.state;
        const { formTitle, formSubTitle } = formData;
        const formSubtitleSplit = getMultilineText(formSubTitle);

        return (
            <div>
                <h1>{formTitle}</h1>
                {formSubtitleSplit.map((subtitle) => (
                    <div key={uniqueId()} className='dashboard-info'>{subtitle}</div>
                ))}
                <div className="category referral">
                    <form>
                        {FormBuilder({
                            isReadOnly: true,
                            formData,
                            handleFieldChange: () => {},
                            handleFieldValidState: () => ({ isValid: true, errorMessage: '' }),
                        })}
                    </form>
                </div>
            </div>
        );
    }
}

UserReferralForm.propTypes = {
    formData: PropTypes.object.isRequired,
    referralCodeData: PropTypes.string,
    actions: PropTypes.object.isRequired,
    isReferralCodeLoaded: PropTypes.bool
};

function mapStateToProps(state) {
    return {
        referralCodeData: state.userAccount.referralCode,
        isReferralCodeLoaded: state.userAccount.isReferralCodeLoaded
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(userAccountActions, dispatch)
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(UserReferralForm);
